import { formatCurrency } from '~/utils/currencyFormatter';

export function formatSupplierCost(cost: number | null | undefined, currencyCode: string | null | undefined): string {
  return cost != null && currencyCode
    ? formatCurrency(cost, currencyCode, 'en-AU', { maximumFractionDigits: 2 })
    : 'N/A';
}
